import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';

import { Observable, ReplaySubject, Subject } from 'rxjs';



import { map, startWith } from 'rxjs/operators';
import { ServiceService } from '../services/service.service';
import { AccessComponent } from './access/access.component';
@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss']
})
export class OverviewComponent implements OnInit {
  @Output() toggleSidebar = new EventEmitter<boolean>();

  displayedColumns: string[] = ["chassisNumber", "batterySerialNumber", 'mobileNumber', 'Access'];
  displayedColumnsTran: string[] = ["createdAt", "swapId", "stationId", 'cost', 'status', 'depositedBattery', 'collectedBattery', 'energy', 'remarks'];
  @ViewChild('transitionPaginator') transitionPaginator: MatPaginator;
  @ViewChild('TableOneSort') tableOneSort: MatSort;
  @ViewChild('TableOneSort') tableTransOneSort: MatSort;
  // BatteryStatus
  @ViewChild(MatPaginator) paginator: MatPaginator;
  // q = {
  //   state: '',
  //   city: ''
  // }
  baseStationDetails; graphRevenueSwaps = {}; assignedUnassignedVehiclesBatteryDetails;
  @ViewChild(MatSort) sort: MatSort; showTable = true; baseStationList; averageData = {};
  cityArr; statesArr; city; state; TotalSwapDetails;
  stations: any;
  swappingStationList;
  swapStationDetails: any;
  swapStationTransaction: any;
  swapStationTransactionDetails;
  totalRevenues: any;
  length: number;

  countryCtrl: FormControl;

  filteredCountry: Observable<any[]>;



  public websiteCtrl: FormControl = new FormControl();
  public websiteFilterCtrl: FormControl = new FormControl();


  @ViewChild('singleSelect', { static: true }) singleSelect: MatSelect;

  protected _onDestroy = new Subject();
  vehicleList: unknown;
  list: any;
  q = {
    chassisNumber: '',
    batterySerialNumber: '',
    model: '',
    vcuNumber: ''

  }

  p = {
    chassisNumber: '',
    firstName: '',
    lastName: '',
    mobileNumber: '',
    dealerName: '',

  }
  chassislist: any;
  objectData: any;
  fail_mgs: any;
  fail_mgss: any;
  failLog: any;
  failLogDetail: any;
  fail_mgsAdd: any;

  @ViewChild('addUserListForm') addUserListForm: NgForm;
  @ViewChild('addUserForm') addUserForm: NgForm;
  isVcuRequired: boolean;
  selectedModel: any;
  fail: any;
  fail_show1 = false;

  constructor(private formBuilder: FormBuilder, private service: ServiceService, private dialog: MatDialog, public dialogRef: MatDialog, private router: Router,) {

  }

  clientId;

  public isVisible: boolean = false;

  filteredOptions;
  currentFilter = '';
  ngOnInit(): void {

    this.getVehicleList();
    this.getVehicle();
    this.getListViewData();
    // this.addUserForm = this.formBuilder.group({
    //   bulkUpload: [''],
    //   clientId: [null, Validators.required],
    // });


  }

  doFilter() {
    this.filteredOptions = this.chassislist.map(filtered => this.filter(filtered))

  }
  showTextField = false;
  onModelChange(event) {
    console.log(event);
    this.selectedModel = event.isVcuRequired;
    console.log("selected", this.selectedModel);

  }







  filter(values) {
    console.log(values);

    if (Array.isArray(values)) {
      return values.filter(auto => auto.auto.toLowerCase().includes(this.currentFilter));
    } else {
      // Handle the case when values is not an array
      console.error('values is not an array');
      return [];
    }
  }

  onToggle() {
    this.toggleSidebar.emit();
  }
  tabClick(e) {
    if (e.index == 0) {
this.getVehicle();
      this.addUserListForm.reset();

      this.fail_mgs = '';
    }
    if (e.index == 1) {

      this.fail = ''
    }
    if (e.index == 2) {
      this.getListViewData();
      console.log("API call")

      this.fail_mgs = '';
    }
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.swappingStationList.filter = filterValue.trim().toLowerCase();

    if (this.swappingStationList.paginator) {
      this.swappingStationList.paginator.firstPage();
    }
  }

  showAlert(): void {
    if (this.isVisible) {
      return;
    }
    this.isVisible = true;
    setTimeout(() => this.isVisible = false, 2500)
  }


  getVehicleList() {
    let type = "Model"
    this.service.getVehicleList(type).subscribe((response: any) => {
      this.vehicleList = response;
      this.list = response.result.list;
      for (let i = 0; i < this.list.length; i++) {
        let obj = {};
        this.isVcuRequired = this.list[i].isVcuRequired;

      }
      console.log("list=", this.list);
    })


  }

  getVehicle() {
    let type = "ChassisNumber"
    this.service.getVehicleList(type).subscribe((response: any) => {
      this.vehicleList = response;
      this.chassislist = response.result
      console.log("list=", this.vehicleList)
    })
  }

  getListViewData() {
    this.service.getVehicleData()
      .subscribe(
        (response: any) => {
          console.log(response);
          if (response.status == "success") {
            this.objectData = response.result;
            this.swappingStationList = new MatTableDataSource(response.result)
            this.swappingStationList.paginator = this.paginator;
            this.swappingStationList.sort = this.sort;
            this.length = response.totalRecords;
            let arr = [];
            for (let i = 0; i < response.result.length; i++) {
              let obj = {};


              if (response.result[i].batterySerialNumber) {
                obj['batterySerialNumber'] = response.result[i].batterySerialNumber;
              } else {
                obj['batterySerialNumber'] = "NA";
              }
              if (response.result[i].chassisNumber) {
                obj['chassisNumber'] = response.result[i].chassisNumber;
              } else {
                obj['chassisNumber'] = "NA";
              }
              obj['type'] = response.result[i].type;
              if (response.result[i].stationId) {
                obj['slot'] = JSON.stringify(response.result[i].liveData);
              } else {
                obj['slot'] = "NA";
              }

              arr.push(obj);

            }

            // this.newDataSource = new MatTableDataSource(arr);

            // setTimeout(() => this.newDataSource.sort = this.sort);

            // this.fail_show = false;

          } else {
            this.fail_mgs = response.message;
            this.fail_show = true;
          }

        }, (error) => {
          console.log(error)
          this.fail_mgs = "Server Error : " + error.error.message;
          this.fail_show = true;
        }
      )
  }



  addUser(form) {
    console.log(form)
    this.service.addUser(form)
      .subscribe(
        (response: any) => {
          console.log("add=", response);
          if (response.status == "success") {
            this.fail_mgs = response.message;
            this.fail_show = true;


            this.addUserForm.reset();




          }
          else {
            this.fail_mgs = response.message;
            this.fail_show = false;

          }
        }, (error) => {
          console.log(error)
          this.fail_mgs = "Server Error : " + error.error.message;
          this.fail_show = true;
        })

  }
  fail_show = false;
  addTryBuyUser(form) {
    console.log(form)
    this.service.addTryBuyUser(form)
      .subscribe(
        (response: any) => {
          console.log("add=", response);
          if (response.status == "success") {
            // alert(response.message);
            // form.reset();
            this.fail = response.message;
            this.fail_show1 = true;
            this.addUserForm.reset();
            this.addUserForm.controls['chassisNumber'].setValue('');
            this.addUserForm.controls['batterySerialNumber'].setValue('');
            this.addUserForm.controls['model'].setValue('');
            this.addUserForm.controls['batterySerialNumber'].setValue('');
          }
          else {
            this.fail = response.message;
            this.fail_show1 = true;
            // alert(response.message);
          }
        }, (error) => {
          console.log(error)
          this.fail_mgs = "Server Error : " + error.error.message;
          this.fail_show = true;
        }
      )
    if (this.isVisible) {
      return;
    }
    this.isVisible = true;
    setTimeout(() => this.isVisible = false, 5500)
  }
  fail__log = false;
  removeAccess(data, access) {
    let dialogRef = this.dialog.open(AccessComponent, {
      width: "538px",
      height: "330px",
      disableClose: true,
      data: { data: data, access: access }

    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
      if (result) {
        this.getListViewData();
        this.fail__log = true;
        this.failLogDetail = result;
        setTimeout(() => this.fail__log = false, 5500)
        console.log("msg", this.failLog);
      }


    });

  }

  logout() {
    sessionStorage.clear();
    // this.token.clear();

    // this.menus.reset();
    this.router.navigateByUrl('');
  }

}
